<template>
  <div class="forbidden-page">
    <i class="el-icon-lock"></i>
    <h2>无权限访问</h2>
    <p>当前账号没有访问该页面的权限。</p>
    <el-button type="primary" size="small" @click="$router.replace('/')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenPage'
};
</script>

<style scoped>
.forbidden-page {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.forbidden-page i {
  font-size: 52px;
  color: var(--brand-primary);
  margin-bottom: 14px;
}

.forbidden-page h2 {
  margin: 0 0 8px;
  color: var(--text-primary);
  font-size: 22px;
}

.forbidden-page p {
  margin: 0 0 18px;
}
</style>
